import { RobotOutlined } from "@ant-design/icons"
import { AiAgents } from "."

export const AI_AGENTS_ROUTES = [
  {
    path: "/ai-agents",
    component: AiAgents
  }
]

export const AI_AGENTS_NAVIGATION = [
  {
    title: "AI Agents",
    path: "/ai-agents",
    submenu: false,
    icon: <RobotOutlined />,
    iconActive: <RobotOutlined />
  }
]
